import { CompaniesListPage } from './CompaniesListPage';
import { withCompaniesList } from './withCompaniesListPage';

const ConnectedCompaniesListPage = withCompaniesList(CompaniesListPage);

export { ConnectedCompaniesListPage as CompaniesListPage };
